import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_USER_LIST_FAIL = "GET_USER_LIST_FAIL";

export interface GetUserListFailAction extends Action {
  type: typeof GET_USER_LIST_FAIL;
  organization: OrganizationKeyName;
}

export const getUserListFailAction = (
  organization: OrganizationKeyName
): GetUserListFailAction => ({
  type: GET_USER_LIST_FAIL,
  organization,
});
